export var RoleName;
(function (RoleName) {
    RoleName["Unspecified"] = "unspecified";
    RoleName["IntentsifyInternal"] = "intentsify-internal";
    RoleName["CustomerFullAccessReadOnly"] = "customer-full-access-read-only";
    RoleName["ContentSyndicationPartner"] = "content-syndication-partner";
    RoleName["IntentsifyContentSyndicationPartner"] = "intentsify-publisher-intentsify";
    RoleName["PermissionsAdmin"] = "permissions-admin";
    RoleName["IntentsifyReadOnly"] = "intentsify-read-only";
    RoleName["CustomerFullAccess"] = "customer-full-access";
    RoleName["IntensifyAdmin"] = "intentsify-admin";
    RoleName["ShouldBeMigrated"] = "should-be-migrated";
})(RoleName || (RoleName = {}));
export var RoleId;
(function (RoleId) {
    RoleId[RoleId["Unspecified"] = 0] = "Unspecified";
    RoleId[RoleId["IntentsifyInternal"] = 1] = "IntentsifyInternal";
    RoleId[RoleId["CustomerFullAccessReadOnly"] = 2] = "CustomerFullAccessReadOnly";
    RoleId[RoleId["ContentSyndicationPartner"] = 3] = "ContentSyndicationPartner";
    RoleId[RoleId["IntentsifyContentSyndicationPartner"] = 4] = "IntentsifyContentSyndicationPartner";
    RoleId[RoleId["PermissionsAdmin"] = 5] = "PermissionsAdmin";
    RoleId[RoleId["IntentsifyReadOnly"] = 6] = "IntentsifyReadOnly";
    RoleId[RoleId["CustomerFullAccess"] = 7] = "CustomerFullAccess";
    RoleId[RoleId["IntentsifyAdmin"] = 8] = "IntentsifyAdmin";
    RoleId[RoleId["ShouldBeMigrated"] = 9] = "ShouldBeMigrated";
})(RoleId || (RoleId = {}));
//# sourceMappingURL=Role.js.map